export default __webpack_public_path__ + "static/media/breakfast5.c104e2cf.png";